var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckLinkInput(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14741_3719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.91174 2.59296C10.0383 1.46639 11.5663 0.833496 13.1595 0.833496C16.4772 0.833496 19.1667 3.52301 19.1667 6.84069C19.1667 8.4339 18.5338 9.96185 17.4072 11.0884L15.0579 13.4377L13.4375 11.8172L15.7868 9.46796C16.4836 8.77117 16.875 7.8261 16.875 6.84069C16.875 4.78866 15.2115 3.12516 13.1595 3.12516C12.1741 3.12516 11.229 3.51661 10.5322 4.21342L8.18295 6.56266L6.5625 4.94221L8.91174 2.59296Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4678 15.7868L11.8171 13.4375L13.4375 15.0579L11.0883 17.4072C9.96169 18.5338 8.43375 19.1667 6.84054 19.1667C3.52286 19.1667 0.833344 16.4772 0.833344 13.1595C0.833344 11.5663 1.46624 10.0383 2.59281 8.91174L4.94206 6.5625L6.56251 8.18295L4.21327 10.5322C3.51646 11.229 3.12501 12.1741 3.12501 13.1595C3.12501 15.2115 4.78851 16.875 6.84054 16.875C7.82595 16.875 8.77101 16.4836 9.4678 15.7868Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37284 14.2479L14.2478 7.3729L12.6274 5.75244L5.75238 12.6275L7.37284 14.2479Z",
    fill: "#64748B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14741_3719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckLinkInput);
export default __webpack_public_path__ + "static/media/check-link-input.c1d7e69f100845348dcbd4b492fe33ff.svg";
export { ForwardRef as ReactComponent };